import React from 'react'
import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { ifElse, prop, always } from 'ramda'
import Button from '../Button'

export const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  border-bottom: 1px solid ${themeColor('harnessTabsBorderBottom')};
`

const ICON_WIDTH = 28
export const Container = styled.div`
  display: inline-flex;
  overflow-x: auto;
  position: relative;
  max-width: ${ifElse(
    prop('showArrows'),
    always(`calc(100% - ${ICON_WIDTH * 3}px)`),
    always(`calc(100% - ${ICON_WIDTH}px)`)
  )};

  &::-webkit-scrollbar {
    display: none;
  }
`

export const AddIcon = styled(({ className, onClick }) => (
  <Button
    type="icon"
    iconProps={{ icon: 'add_circle_outlined', fill: 'btnSecondaryColor' }}
    className={className}
    onClick={onClick}
    round={true}
  />
))`
  align-self: center;
  flex-shrink: 0;
`

export const LeftIcon = styled(({ className, onClick }) => (
  <Button
    type="icon"
    iconProps={{ icon: 'chevron_left' }}
    className={className}
    onClick={onClick}
  />
))`
  align-self: center;
  flex-shrink: 0;
`

export const RightIcon = styled(({ className, onClick }) => (
  <Button
    type="icon"
    iconProps={{ icon: 'chevron_right' }}
    className={className}
    onClick={onClick}
  />
))`
  align-self: center;
  flex-shrink: 0;
`
